import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

export default () => {
  Vue.use(VueClipboard)
}
